import isEmpty from 'ramda/es/isEmpty';
import { useContext } from 'react';
import useHeaderAccountModal from '@/SearchResults/useHeaderAccountModal';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import ModalContext from '~/contexts/ModalContext';
import UserContext from '~/contexts/UserContext';
import HeartIcon from '~/icons/HeartIcon';
import useSavedSearchApplied from './useSavedSearchApplied';

const SaveSearchButton = () => {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { setCreateSavedSearchOpen } = useContext(ModalContext);
  const { triggerFetchUserProfile } = useContext(UserContext);
  const successHandler = async () => {
    triggerFetchUserProfile();
    setCreateSavedSearchOpen(true, appliedFilters);
  };

  const openModal = useHeaderAccountModal({
    successHandler,
    openModal() {
      setCreateSavedSearchOpen(true, appliedFilters);
    }
  });

  const savedSearchIsApplied = useSavedSearchApplied();
  const savedSearchIsDisabled = isEmpty(appliedFilters);

  return (
    <button
      type="button"
      className="bg-transparent border-none disabled:text-grey-3 p-0 relative text-blue-6"
      data-analytics-id="Search - Save Search Button"
      onClick={openModal}
      disabled={savedSearchIsDisabled}
    >
      <HeartIcon
        className="mr-[8px] relative top-[3px]"
        isSavedSearch={savedSearchIsApplied}
      />
      <span className="t-header-xs m:t-header-s">Save Search</span>
    </button>
  );
};

export default SaveSearchButton;
